// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"nb","editButton":"nc","formClass":"nd","rowClass":"ne","columnClass":"nf","inputClass":"nh","email":"ni","mobile":"nj","cancelButton":"nk","submitButton":"nl"};